'use client';

import useSWR, { useSWRConfig } from 'swr';
import { unstable_serialize } from 'swr/infinite';
import {
  getChatHistoryPaginationKey,
} from '@/components/sidebar-history';
import type { VisibilityType } from '@/components/visibility-selector';
import { apiClient } from '@/lib/api-client';

export function useChatVisibility({
  chatId,
  initialVisibilityType,
}: {
  chatId: string;
  initialVisibilityType: VisibilityType;
}) {
  const { mutate } = useSWRConfig();

  // This is the key: shared SWR cache with same key for same chatId
  const { data: visibilityType, mutate: setLocalVisibility } = useSWR(
    `${chatId}-visibility`,
    null,
    {
      fallbackData: initialVisibilityType,
    },
  );

  const setVisibilityType = async (updatedVisibilityType: VisibilityType) => {
    setLocalVisibility(updatedVisibilityType);
    mutate(unstable_serialize(getChatHistoryPaginationKey));

    try {
      await apiClient.updateSessionVisibility(chatId, updatedVisibilityType);
    } catch (error) {
    }
  };

  return { visibilityType, setVisibilityType };
}
